// extracted by mini-css-extract-plugin
export default {"coming":"UpComing_coming__dzhSp"};